import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import type {Variant} from './IconNumber.types'

export const classes = {
  root: css`
    block-size: ${spacing(3)};
    inline-size: ${spacing(3)};
    font-size: ${spacing(1.75)};
    font-weight: 700;
    color: ${cssTheme.default.day.textInvert};
    position: relative;

    :before,
    :after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    :before {
      content: '';
      block-size: ${spacing(2.5)};
      inline-size: ${spacing(2.5)};
      border-radius: 50%;
      background-color: ${cssTheme.colors.deliveryGrey[450]};
    }

    :after {
      content: attr(data-number);
    }
  `,
}
export const variantClasses: Record<Variant, string> = {
  red: css`
    :before {
      background-color: ${cssTheme.colors.red.normal};
    }
  `,
  gray: css`
    :before {
      background-color: ${cssTheme.colors.deliveryGrey[300]};
    }
  `,
  black: css`
    :before {
      background-color: ${cssTheme.colors.deliveryGrey[450]};
    }
  `,
}
